/* eslint-disable prettier/prettier */
import { ProductFragment } from '@core-mkt/shared/craft/product-entry-fragment';
import * as gql from 'fake-tag';

export const ProductCardFragment = {
  ProductCard: gql`
    fragment ProductCardQuery on productCards_Entry {
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      ctaStyle
      filterType
      hideCta
      lineBreak_content
      lineBreak_styles
      useCompactCards
      showCompactStrikethrough
      productCardList {
        ... on productCardListBlock_Entry {
          cardTitle {
            html
          }
          ctaLabel
          ctaLink
          ctaNewTab
          ctaNofollow
          learnMoreLabel
          learnMoreLink
          learnMoreNewTab
          learnMoreNofollow
          productEntry {
            ...ProductEntry
          }
          showSavings
          showPriceText
          starCaption
          starRating
          styles
          textContent {
            html
          }
          topContent
          topContentStyles
        }
      }
      sectionTitle
      styles
      typeHandle
    }
    ${ProductFragment.product}
  `,
};
